import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { useCallback } from 'sb-hooks'

import { Box } from 'components/_new/layout'
import { Field, FieldState } from 'components/_new/forms'
import { EmailSuggestion } from 'components/_new/auth/EmailSuggestion'

import Tags from './Tags/Tags'

import messages from './messages'


const EmailField = ({ className, field, standardView, loading, withTags, onBlur, onChange }) => {
  const handleEmailUpdate = useCallback((value) => {
    field.set(value)

    if (typeof onChange === 'function') {
      onChange(value)
    }
  }, [ onChange ])

  const fieldProps = {
    [standardView ? 'placeholder' : 'label']: messages.label,
    standardView,
  }

  return (
    <Fragment>
      <Field
        className={className}
        id="emailRegister"
        field={field}
        type="email"
        onBlur={onBlur}
        loading={loading}
        onChange={onChange}
        autoComplete="email"
        dataTestId="emailField"
        {...fieldProps}
      />
      <FieldState field={field}>
        {
          ({ value, error }) => withTags ? (
            <Box pt={Boolean(!error) && 16}>
              <Tags
                email={value}
                onTagClick={handleEmailUpdate}
              />
            </Box>
          ) : (
            <EmailSuggestion
              email={value}
              onConfirm={handleEmailUpdate}
            />
          )
        }
      </FieldState>
    </Fragment>
  )
}

EmailField.propTypes = {
  className: PropTypes.string,
  field: PropTypes.object.isRequired,
  standardView: PropTypes.bool,
  loading: PropTypes.bool,
  withTags: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
}

EmailField.defaultProps = {
  withTags: false,
}


export default EmailField
